const imagePlayerReducer = (state = {
  isVisible: false,
  imagePlayerImages: [],
  initialIndex: 0,
}, action) => {
  switch (action.type) {
    case 'CLOSE_IMAGEPLAYER':
      return {
        ...state,
        isVisible: action.isVisible,
      };
    case 'OPEN_IMAGEPLAYER':
      return {
        ...state,
        isVisible: action.isVisible,
      };
    case 'SET_IMAGEPLAYER_IMAGES':
      return {
        ...state,
        imagePlayerImages: action.imagePlayerImages,
      };
    case 'SET_INITIAL_INDEX':
      return {
        ...state,
        initialIndex: action.initialIndex,
      };
    default:
      return { ...state };
  }
};

export default imagePlayerReducer;



// WEBPACK FOOTER //
// ./frontend/js/Base/Reducers/imagePlayerReducer.jsx